import { render, staticRenderFns } from "./OptionsList.vue?vue&type=template&id=fdf84a4a&scoped=true&"
import script from "./OptionsList.vue?vue&type=script&lang=js&"
export * from "./OptionsList.vue?vue&type=script&lang=js&"
import style0 from "./OptionsList.vue?vue&type=style&index=0&id=fdf84a4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf84a4a",
  null
  
)

export default component.exports